import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { endSession } from "../../../middleware/session";
import OfflineImage from '../../../images/OfflineImage.svg'
interface MenuProps {
  picture?: string;
 // user :IUser
}
const MenuBarComponent: React.FC<MenuProps> = (props) => {
  const { logout } = useAuth0();
  const [error, setError] = useState(false);
  // Auth0's default (no custom upload) picture is a Gravatar URL that falls back to
  // cdn.auth0.com's initials avatar, proxied through i0.wp.com. That fallback chain is
  // unreliable on networks that block wp.com, so skip requesting it and go straight to
  // the local placeholder instead of letting the request fail.
  const isUnreliableGravatarAvatar = !!props?.picture?.includes("gravatar.com");

  function LogOutUser() {
    endSession(logout);
  }
  const handleImageError = () => {
    // Handle the image error (e.g., set an error state or load a fallback image)
    setError(true);
  };

  return (
    <div className='btn-group'>
      <button
        type='button'
        className='border-none mb-2 mb-lg-0 text-center'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        {props?.picture && (
          <div className="col-2 col-lg-1 px-3">
            {error || isUnreliableGravatarAvatar ? (
              <img
                className="img-user-icon"
                src={OfflineImage}
                alt={`${logout?.name}_alt`}
                width={40}
              />
             ) : (
               <img
                 src={props?.picture}
                 alt={`${logout?.name}_alt`}
                 className="img-user-icon"
                 width={40}
                 onError={handleImageError}
               />
             )}
          </div>
        )}

        {/* <img
          className='img-user-icon'
          src={props?.picture}
          alt='User incon picture'
          width={40}
        /> */}
      </button>

      <ul className='dropdown-menu dropdown-menu-end mb-2 ms-2'>
        <li>
          <Link className='dropdown-item mx-0 px-0' to='/profile'>
            <i className='fas fa-id-card profile-icons text-12'>
              <span className='text-submenus text-12'> Profile</span>
            </i>
          </Link>
        </li>
        <li>
          <a className='dropdown-item mx-0 px-0' onClick={() => LogOutUser()}>
            <i className='fas fa-power-off profile-icons text-12'>
              <span className='text-submenus text-12'> Log Out</span>
            </i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default MenuBarComponent;
